export const getAuthToken = () => {
  return localStorage.getItem("authToken") || ""
}

export const setAuthToken = token => {
  if (!token) {
    return false
  }
  localStorage.setItem("authToken", token)
  return true
}

export const removeAuthToken = () => {
  localStorage.removeItem("authToken")
  return true
}

export const getUserInfo = () => {
  let userInfo = localStorage.getItem("userInfo")
  return userInfo ? JSON.parse(userInfo) : null
}

export const setUserInfo = userInfo => {
  if (!userInfo) {
    return false
  }

  userInfo = JSON.stringify(userInfo)
  localStorage.setItem("userInfo", userInfo)
  return true
}

export const removeUserInfo = () => {
  localStorage.removeItem("userInfo")
  return true
}

export const getApiConfig = isFormData => {
  let config = {}
  config = {
    "Content-Type": "multipart/form-data",
  }
  let token = getAuthToken()

  if (token) {
    let headers = {}
    if (isFormData) {
      headers = {
        "Content-Type": `multipart/form-data`,
        authorization: token,
      }
    } else {
      headers = {
        authorization: token,
      }
    }

    config = {
      ...config,
      headers,
    }
  }
  return config
}
